import { useEffect } from 'react';

export const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | DreamableAI` : 'DreamableAI - Create Beautiful AI Greeting Cards';
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle; 